import { Tracking } from "Types/api/Tracking";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import {
    patchTrackingFailure,
    patchTrackingRequest,
    patchTrackingSuccess,
    setTracking,
} from "src/store/actions/tracking";

export type TrackingState = Tracking;

function reducer(
    state: TrackingState = {},
    action:
        | ActionType<typeof patchTrackingRequest>
        | ActionType<typeof patchTrackingSuccess>
        | ActionType<typeof patchTrackingFailure>
        | ActionType<typeof setTracking>
): TrackingState {
    switch (action.type) {
        case setTracking.type:
        case patchTrackingRequest.type:
            return { ...state, ...action.payload.tracking };

        case patchTrackingSuccess.type:
            return state;

        case patchTrackingFailure.type:
            return state;

        default:
            return state;
    }
}

export default reducer;
